/**
 * CoffeeMates Master Class Service
 */

import httpClient from '../utils/httpClient';

export interface MasterClassEvent {
  id: string;
  title: string;
  description: string;
  event_type: string;
  scheduled_date: string;
  scheduled_time: string | null;
  status: string;
  requires_approval: boolean;
  masterclass_fee: number;
  voucher_tier: string;
  current_count: number;
  max_capacity: number;
  attendee_count: number;
  revenue_estimate: number;
  avg_rating: number | null;
  venue_id: string | null;
}

export interface CreateMasterClassData {
  title: string;
  description: string;
  topic_brief?: string;
  zone_id: string;
  venue_id?: string;
  scheduled_date: string;
  scheduled_time: string;
  duration_minutes?: number;
  masterclass_fee?: number;
  voucher_tier?: string;
  min_capacity?: number;
  max_capacity?: number;
}

const masterclassService = {
  async create(data: CreateMasterClassData) {
    const { data: result } = await httpClient.post('/masterclass/create', data);
    return result;
  },

  async getMyEvents(): Promise<MasterClassEvent[]> {
    const { data } = await httpClient.get<MasterClassEvent[]>('/masterclass/my');
    return data;
  },

  async update(eventId: string, data: Partial<CreateMasterClassData>) {
    const { data: result } = await httpClient.put(`/masterclass/${eventId}`, data);
    return result;
  },

  async cancel(eventId: string) {
    const { data: result } = await httpClient.del(`/masterclass/${eventId}`);
    return result;
  },
};

export default masterclassService;
